module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2017/may-bf2fd502ad875dbdba044ee66a722d7f.png";